import {
  Card,
  CardActionArea,
  CardContent,
  Grid,
  LinearProgress,
  linearProgressClasses,
  Stack,
  styled,
  Typography
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_EMPOYEES_JOB_4 } from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientQualityControl() {
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const { TEXT_PROGRESS, TEXT_NO_QUALITY_JOBS } = ClientEnglishFallback.QualityControl(
    multiLanguageData?.QualityControl || {}
  );
  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const [jobList, setJobsList] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const location = useLocation();

  const nav = useNavigate();

  useEffect(() => {
    if (selectedClientData?.ClientEmployeeId) {
      fetchJobs();
    }
  }, [location]);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: location?.state?.searchText || "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ],
        SortList: [{ FieldName: "JobName", Direction: "ASC" }]
      };

      let res = await Postrequestcall(FETCH_CLIENT_EMPOYEES_JOB_4, obj, loginData?.accessToken);
      if (res?.status === 200) {
        let data = res?.data?.data;

        setLoading(false);
        setJobsList(data);
      }
    } catch (error) {
      console.error("fetchJobs-> error ::::::::", error);
      setLoading(false);
    }
  };

  const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    borderRadius: 5,
    [`&.${linearProgressClasses.colorPrimary}`]: {
      backgroundColor: theme.palette.grey[200],
      ...theme.applyStyles("dark", {
        backgroundColor: theme.palette.grey[800]
      })
    },
    [`& .${linearProgressClasses.bar}`]: {
      borderRadius: 5,
      backgroundColor: "#1a90ff",
      ...theme.applyStyles("dark", {
        backgroundColor: "#308fe8"
      })
    }
  }));

  const handelNavigate = (item) => {
    nav(`${item?.id}`); // navigate to details page;
  };
  return (
    <>
      <div className="page">
        <div className="page-content" style={{ marginTop: "20px" }}>
          {isLoading ? (
            <Loader fullScreen={true} />
          ) : (jobList?.length > 0) ? (
            <Grid container size={12} spacing={2}>
              {jobList?.map((item, index) => (
                <Grid
                  size={{
                    xs: 6,
                    sm: 6,
                    md: 4,
                    lg: 3,
                    xl: 2
                  }}
                  key={index}>
                  <Card>
                    <CardActionArea
                      onClick={() => {
                        handelNavigate(item);
                      }}>
                      <CardContent>
                        <Stack display={"flex"} height={200} justifyContent={"space-between"}>
                          <Stack>
                            <Typography
                              gutterBottom
                              variant="subtitle2"
                              fontSize={17}
                              component="div"
                              fontWeight={"bold"}
                              color={"grey"}>
                              {item?.jobName}
                            </Typography>
                            <Typography
                              gutterBottom
                              variant="subtitle1"
                              component="div"
                              color={"grey"}>
                              {item?.jobCode}
                            </Typography>
                          </Stack>
                          <Stack
                            sx={{
                              width: "100%"
                            }}
                            mb={2}>
                            <Typography
                              gutterBottom
                              variant="subtitle2"
                              fontSize={17}
                              component="div"
                              fontWeight={"bold"}
                              color={"grey"}>
                              {TEXT_PROGRESS}
                            </Typography>
                            <BorderLinearProgress
                              sx={{
                                backgroundColor: "white",
                                "& .MuiLinearProgress-bar": {
                                  backgroundColor: CLIENT_ACCENT_COLOR,
                                  width: "100%"
                                }
                              }}
                              variant="determinate"
                              value={item?.qualityControlProgress}
                            />
                          </Stack>
                        </Stack>
                      </CardContent>
                    </CardActionArea>
                  </Card>
                </Grid>
              ))}
            </Grid>
          ) : (
            <Stack sx={{ width: "100%" }} justifyContent="center" alignItems="center" height="85vh">
              <Typography>{TEXT_NO_QUALITY_JOBS}</Typography>
            </Stack>
          )}
        </div>
      </div>
    </>
  );
}
